import { Button } from './Button';

export type { ButtonProps } from './types';
export default Button;
